import SolarContact from './SolarContact';
export { SolarContact as default };
